import accounting from 'accounting'

export default {
    data () {
        return {
            activeType: 1,
            bets: [],
            EventGroup: [],
            walletType: 1,
            firstCombineSelected: false,
            maxStake: 0,
            currentFixtureState: 0,
            selectedBets: [],
            confirmationType: 2,
            sameEvents: 0,
            subEarnings: 0,
            uniqueEventIds: 0,
            couponTypes: [
                {type: 'single', id: 1},
                {type: 'multiple', id: 2},
                {type: 'system', id: 3}
            ],
            confirmationTypes: [
                {name: 'agreement_high_odds', id: 1},
                {name: 'agreement', id: 2},
            ]
        }
    },
    methods: {
        changeWalletType (type){
            this.walletType = type;
        },
        getBetListGroup () {
          this.bets.forEach((item) => {
              if(this.findByKey(this.EventGroup, 'eventId', item.eventId)){

                  this.findByKey(this.EventGroup, 'eventId', item.eventId).bets.push(item);

              }else {
                  this.EventGroup.push({
                      eventId: item.match.matchId,
                      match: item.match,
                      bets: [item]
                  });
              }
          });

        },
        countRepeatedEvents() {
            // Create an object to store counts
            const counts = {};
            
            // First pass: count occurrences of each eventId
            for (const item of this.bets) {
              const eventId = item.eventId;
              
              if (counts[eventId]) {
                counts[eventId]++;
              } else {
                counts[eventId] = 1;
              }
            }
            
            // Second pass: filter out eventIds that only appear once
            const repeatedEvents = {};
            for (const eventId in counts) {
              if (counts[eventId] > 1) {
                repeatedEvents[eventId] = counts[eventId];
              }
            }
            
            return repeatedEvents;
          },
        addBet(bet, market, match) {

            this.selectedSystem = []

            if (!bet.active) {
                return false;
            }

            if (bet.odd === '1.00') {
                return false;
            }

            var bet = {
                eventId: match.matchId,
                name: market.name,
                oddId: bet.id,
                exc: bet.exc,
                oddType: bet.oddType,
                odd: bet.odd,
                outCome: bet.outcome,
                checked: true,
                specialValue: market.sp,
                stake: 0.00,
                banker: false,
                match: match,
                active: bet.active,
                live: bet.live,
                tss: match.ts
            };

  
            this.$getItem('bets', (key, value) => {
                //console.log all the kay/value pairs

                if(!value) {
                    value = [];
                } 

                if (this.findByKey(value, 'oddId', bet.oddId)) {
                    this.findByKeyAndRemove(value, 'oddId', bet.oddId);

                    //document.querySelector(".odd-c-"+bet.oddId).classList.remove('active');

                    this.$store.commit("removeMarket", bet);

                    const index = window.selectedBets.indexOf(bet.oddId);
                    if (index > -1) { // only splice array when item is found
                    window.selectedBets.splice(index, 1); // 2nd parameter means remove one item only
                    }
                    
                }else{

                    window.selectedBets.push(bet.oddId);

                    if( this.findByKey(value, 'oddId', bet.eventId) ) {
                        this.findByKeyAndRemove(value, 'oddId', bet.eventId);

                        value.push(bet);
                    }else{
                        value.push(bet);
                    }
                }

                var valueArr = value.map(function(item){ return item.eventId });
                var isDuplicate = valueArr.some(function(item, idx){ 
                    return valueArr.indexOf(item) != idx 
                });

                if(isDuplicate){

                    setTimeout(() => {
                        this.sameEvents = 1;

                        if(this.activeType = 2) {
                            this.currentType = 1;
                            this.activeType = 1;
                        }
            
                        if(value.length > 2 && this.possibleCombinations.length > 2){
                            this.activeType = 3;
                            this.currentType = 3;
                        }
                    }, 1000);

                }else {
                    this.sameEvents = 0;

                    if (value.length > 1) {
                        this.activeType = 2;
                        this.currentType = 2;
                     }else {
                        this.activeType = 1;
                        this.currentType = 1;
                     }
                }

                /*
                if(this.bets.length > 1 && !this.firstCombineSelected && this.sameEvents === 0){

                    this.activeType = 2;
                    this.currentType = 2;

                    this.firstCombineSelected = true;
                }else if(this.firstCombineSelected && this.bets.length == 1) {
                    this.activeType = 1;
                    this.currentType = 1;
                    this.firstCombineSelected = false;
                } */


                //console.log(value);
                //this.fetchBets();
                setTimeout(this.fetchBets(), 300);
                this.updateBets(value);
                //setTimeout(this.detectSameEvents(), 300);

            }, function (err) {

                this.$setItem('bets', []);
            })
            //this.checkBetCurrentValue();
        },
        selectSystem (system, s) {
            if (typeof this.selectedSystem[s] === 'object' ) {
                this.selectedSystem[s] = undefined;
            } else {
                this.selectedSystem[s] = system;
            }
            this.fetchBets();
        },
        computeCoupon (coupon) {
            var odd = 1;

            if (typeof coupon === 'object' ) {
                for (var i = 0; i < coupon.length; i++) {
                    odd = Number(odd * coupon[i].odd);

                }
            }

            if (this.activeType == 3) {
                for (var i = 0; i < this.bankers.length; i++) {
                    odd = Number(odd * this.bankers[i].odd) ;
                }
            }

            return odd;
        },
        computeOdds () {

            this.odds = 0;

            var odd = [];
            if (this.activeType == 3) {
                var systemOdd = 0;
                this.totalBets = 0;
                this.odds = 0;   
                this.totalBonus = 0;             

                for (var is = 0; is < this.selectedSystem.length; is++) {

                    if ( this.systemCombinations[is] && this.isSelectedSystem(is) ) {
                        odd[is] = [];
                        this.totalBets += this.selectedSystem[is].bets;
                    }

                }

                this.betPer = this.amount / this.totalBets;

                for (var i = 0; i < this.systemCombinations.length; i++) {
                    var perBet = 0
                    if (this.systemCombinations[i] && this.isSelectedSystem(i)) {

                        for (var ci = 0; ci < this.systemCombinations[i].length; ci++) {
                            //odd[this.systemCombinations[i].length].push(Number(this.computeCoupon(this.systemCombinations[i])));
                            this.odds += Number(this.computeCoupon(this.systemCombinations[i][ci]));
                            //perBet = this.amount / this.selectedSystem[this.systemCombinations[i].length].bets;
                            perBet = this.betPer;
                            this.totalBonus += perBet * this.computeCoupon(this.systemCombinations[i][ci])
                            
                        }

                    }
                }

                for (var i = 0; i < this.bankers.length; i++) {

                    this.odds = Number(this.odds * this.bankers[i].odd) ;

                }
            }

            if (this.activeType == 2) {
                this.odds = 1;
                this.totalBets = 1;

                for (var i = 0; i < this.bets.length; i++) {

                    this.odds = (this.bets[i].checked) ? Number(this.odds * this.bets[i].odd) : this.odds;

                }
            }

            if (this.activeType == 1) {
                this.odds = 1;
                this.totalBets = 0;
                this.totalBonus = 0;

                var perBetAmountTotal = 0;
                var perBetAmount = Number(this.toFloat(this.amount) / this.bets.length).formatMoney(2, '.', ',');
                this.betPer = perBetAmount;

                for (var i = 0; i < this.bets.length; i++) {

                    this.odds = (this.bets[i].checked) ? Number(this.odds * this.bets[i].odd) : this.odds;
                    this.bets[i].stake = perBetAmount;

                    this.totalBets += (this.bets[i].checked) ? 1 : 0;

                    this.totalBonus += Number(this.bets[i].stake * this.bets[i].odd);

                }

            }

        },
        prepareBets () {

            var a = [];
            this.bets.forEach((item) => {

                a.push(
                    {
                        eventId: item.eventId,
                        banker: item.banker,
                        odd: item.odd,
                        oddId: item.oddId,
                        exc: item.exc,
                        isLive: item.live,
                        ts: item.tss
                    }
                )
            })
            return a;
        },
        checkBetCurrentValue () {
            this.prepareBets()
            var AppId = this.$root.app.id;

            this.$http.post(bsapi+'api/v1/checkBets', {walletType: this.walletType, type: this.activeType,bets: this.prepareBets(), systems: this.getActiveSystems(), amount: this.toFloat(this.amount),
                    appToken: window.auth.accessToken, app:AppId},
                { headers: { 'X-App': '' +AppId } }

            ).then(
                response => {
                    // get body data
                    this.maxStake = response.body.maxStake;

                    if (response.body.errors.bets) {
                        this.betErrors = [];
                        setTimeout(() => {
                            this.betErrors = response.body.errors.bets;
                        }, 1000);
                    }else {
                        this.betErrors = [];
                    }

                    if(response.body.bets) {

                        response.body.bets.forEach( (v,k) => {

                            this.bets.forEach((item) => {

                                //var cm = (item.oddType === 5500 || item.oddType === 5520) ? (item.tss === v.entity.match.total_score) : true;

                                //if(!cm)
                                  //  this.betErrors[item.oddId] = {msg: "Closed"}

                                if(item.oddId == v.entity.id)
                                {
                                    item.odd = v.value;
                                    item.maxStake = v.entity.playable_max_stake;
                                }

                            })

                        })

                        this.updateBets(this.bets);
                    }

                }, response => {


                })
        },
        reuseBet(id){
            this.$http.get(bsapi + 'api/v1/bet/detail/'+id, {
                params: {
                    _locale: session.locale.locale
                }
            }).then(response => {
                var value = [];
                response.body.result.items.forEach((i) => {

                    var bet = {id: i.selectionId, exc: '', outcome: i.selection, sp: '', odd: i.oddValue
                        , oddType: i.oddType, active: 1, live: 1};
                    var market = {name: i.name}
                    var match = {matchId: i.mid, name: i.fcName +' - '+ i.scName, competitor: {oneName: i.fcName, twoName: i.scName}};

                    var bet = {
                        eventId: match.matchId,
                        name: market.name,
                        oddId: bet.id,
                        exc: bet.exc,
                        oddType: bet.oddType,
                        odd: bet.odd,
                        outCome: bet.outcome,
                        checked: true,
                        specialValue: bet.sp,
                        stake: 0.00,
                        banker: false,
                        match: match,
                        active: bet.active,
                        live: bet.live
                    };

                })

                this.$setItem('bets', value);
                //console.log(value);
                this.updateBets(value);

                setTimeout(() => {
                    this.$router.replace({name: 'betSlip'})
                }, 2000)
            })
        },
        betPlace (amount = 0) {
            this.checkBetCurrentValue();

            if(amount > 0)
                this.amount = amount;

            if (window.session.uid == 0) {
                swal(this.t.processing.error, this.t.auth.bet_auth, "error")
                return false
            }

            this.$bus.$emit('betCreating', true);

            var AppId = this.$root.app.id;

            this.$http.post(bsapi+'api/v1/betPlace', {
                walletType: this.walletType, confirmationType: this.confirmationType,
                    type: this.activeType,bets: this.prepareBets(), systems: this.getActiveSystems(),
                    amount: this.toFloat(this.amount), appToken: window.auth.accessToken, app:AppId},

                { headers: { 'X-App': '' +AppId } }

            ).then(
                response => {
                    // get body data

                    this.$bus.$emit('betCreated', true);
                    setTimeout(this.clear, 1500);

                }, response => {

                    if (response.body.error == 'bet_error') {
                        this.$bus.$emit('betError', true);

                        this.errors = response.body.errors;

                        if (response.body.errors.bets) {
                            this.betErrors = response.body.errors.bets;
                        }
                    }else {
                        this.errors = null;
                    }
                })
        },
        getActiveSystems () {
            var activeSystems = new Array();

            if(this.selectedSystem) {
                for (var i = 0; i < this.selectedSystem.length; i++) {
                    if (typeof this.selectedSystem[i] === 'object' && i < this.bets.length) {
                        activeSystems.push(i);
                    }
                }
            }

            return Array.from(new Set(activeSystems) );
        },
        isSelectedSystem (s) {
            if (typeof this.selectedSystem[s] === 'object' ) {
                return true;
            } else {
                return false;
            }
        },
        syncSelectionClass () {

            //var list;
            //list = document.querySelectorAll('.active-odd-button');
            //for (var i = 0; i < list.length; ++i) {
             //   list[i].classList.remove('active-odd-button');
           // }

           /*
            this.$getItem('bets', (key, value) => {
                value.forEach((v, k) => {
                    var list;
                    list = document.querySelectorAll('.odd-c-'+v.oddId);
                    for (var i = 0; i < list.length; ++i) {
                        list[i].classList
                        if (!list[i].classList.contains('active-odd-button'))
                            list[i].classList.add('active-odd-button');
                    }
                });
                
            }); */
        },
        updateBets (bets) {

            this.$setItem('bets', bets, (key, value) => {
                //this.$bus.$emit('addBet', bets);
                //this.syncSelectionClass();

                value.forEach((v,k) => {
                    this.$store.commit("updateActiveMarket", v);
                })

            });

            setTimeout(() => {
                this.bets = bets
            }, 100)


            this.$setItem('selectedBets', this.selectedBets, (key, value) => {

            });

            this.getBetListGroup()
        },
        detectSameEvents (bets) {
  
            return this.sameEvents
        },
        removeBet (bet) {
            this.selectedSystem = []
            this.findByKeyAndRemove(this.bets,'oddId', bet.oddId);
            this.$store.commit("removeMarket", bet);
            this.updateBets(this.bets)
            //this.checkBetCurrentValue();

            const index = window.selectedBets.indexOf(bet.oddId);
            if (index > -1) { // only splice array when item is found
                window.selectedBets.splice(index, 1); // 2nd parameter means remove one item only
            }
        },
        clear () {
            this.$getItem('bets', (key, value) => {

                value.forEach((v,k) => {
                    setTimeout(() => {
                        this.$store.commit("removeMarket", v);
                    }, 100)
                })
            });
            this.updateBets([]);
        },
        isBetAvailable (oddId) {
            if (typeof this.betErrors[oddId] !== 'undefined') {
                // your code here
                return this.betErrors[oddId];
            }
            return false;
        },
        setBanker (bet) {

            if ( 3 < (this.bets.length - this.bankers.length) ) {
                bet.banker = (bet.banker) ? false : true;
            }else {
                bet.banker = false;
            }

            this.updateBets(this.bets);

            this.selectedSystem = [];
        },
        changeCouponType  (type) {

            this.activeType = type;
            this.selectedSystem = [];

            this.fetchBets();
        },
        fetchBets() {
            var betList = []
            this.$getItem('bets', (key, value) => {
                //console.log all the kay/value pairs


                this.bets.forEach((item) => {
                    betList.push(item.oddId)
                })

                if (!value){
                    this.updateBets([]);
                }

                this.bets = value;

                setTimeout(() => {
                    if(this.bets.length < 15 && this.currentType === 3){
                        this.fetchSystemBets();
                        this.systemCombinations = this.combinations(this.systemBets);
                        this.possibleCombinations = this.getPossibleCombinations(this.systemBets);
                    }else {
                        this.possibleCombinations = [];
                    }
                    if (this.selectedSystem.length == 0){
                        this.selectedSystem = []

                        if (this.possibleCombinations.length > 0)
                            setTimeout(this.selectSystem(this.possibleCombinations[this.possibleCombinations.length - 1], this.possibleCombinations[this.possibleCombinations.length - 1].system), 1000)

                        //this.possibleCombinations.forEach((v,s) => {
                          //  setTimeout(this.selectSystem(this.possibleCombinations[this.possibleCombinations.length - 1], this.possibleCombinations[this.possibleCombinations.length - 1].system), 1000)
                         //})
                    }

                    if (this.sameEvents > 0 && this.activeType == 2){
                        this.activeType = 1
                        this.currentType = 1
                    }
                }, 500);

                this.computeOdds();

            }, function (err) {

            })

            setTimeout(() => {
                if (window.selectedBets.length == 0) {
                    console.log(betList)
                    window.selectedBets = betList
                }
            }, 300)

        },
        getOutcomeSelection (OutCome, Match) {
            var ou;

            return OutCome;
        },
        openMatch (m) {

            this.$bus.$emit('openMatchOdd', m);
        },
        findByKeyCount (source, key, find) {
            var count = 0;
            for (var i = 0; i < source.length; i++) {
                if (source[i][key] === find) {
                    count = count + 1;
                }
            }
            return count;
        },
        findByKey (source, key, find) {
            for (var i = 0; i < source.length; i++) {
                if (source[i][key] === find) {
                    return source[i];
                }
            }
            return false;
        },
        findByKeyAndRemove (source, key, id) {
            for (var i = 0; i < source.length; i++) {
                if (source[i][key] === id) {
                    source.splice(i, 1);
                }
            }
            return false;
        },
        listPossibleCombinations(bets) {
            const uniqueEventIds = [...new Set(bets.map(bet => bet.eventId))];
            const possibleSizes = [];
        
            for (let i = 1; i <= uniqueEventIds.length; i++) {
                const totalCombinations = getSystemCombinations(bets, i).length;
                possibleSizes.push(`${i}/${uniqueEventIds.length} (Total Bets: ${totalCombinations})`);
            }
        
            return possibleSizes;
        },
        getPossibleCombinations(bets) {
            this.uniqueEventIds = [...new Set(bets.map(bet => bet.eventId))];
            const combs = [];
        
            for (let i = 1; i <= this.uniqueEventIds.length; i++) {
                const combination = this.getSystemCombinations(bets, i)
                const totalCombinations = combination.length;
                //console.log(`${i}/${this.uniqueEventIds.length} (Total Bets: ${totalCombinations})`)
               // possibleSizes.push(`${i}/${uniqueEventIds.length} (Total Bets: ${totalCombinations})`);
                //combs[totalCombinations] = (totalCombinations) ? {system: totalCombinations, bets: totalCombinations, selected: this.isSelectedSystem(i)} : {system: totalCombinations, bets: 1, selected: this.isSelectedSystem(i)};
                //combs.push({system: totalCombinations, bets: totalCombinations, selected: this.isSelectedSystem(i)})
                combs[i] = {system: i, bets: totalCombinations, selected: this.isSelectedSystem(i)}
            }
        
            return combs;
        },
        /*
        getPossibleCombinations (set) {
            var k, i, combs, k_combs;
            combs = [];

            // Calculate all non-empty k-combinations
            for (k = 1; k <= set.length; k++) {
                k_combs = this.getSystemCombinations(set, k);

                for (i = 0; i < k_combs.length; i++) {
                    combs[k_combs[i].length] = (combs[k_combs[i].length]) ? {system: k_combs[i].length, bets: Number ( combs[k_combs[i].length].bets + 1), selected: this.isSelectedSystem(i)} : {system: k_combs[i].length, bets: 1, selected: this.isSelectedSystem(i)};
                }
            }
            return combs;
        }, */
        getSystemCombinations(bets, combinationSize) {
            const eventMap = new Map();
        
            // Group bets by eventId
            for (const bet of bets) {
                if (!eventMap.has(bet.eventId)) {
                    eventMap.set(bet.eventId, []);
                }
                eventMap.get(bet.eventId).push(bet);
            }
        
            const eventGroups = Array.from(eventMap.values());
        
            // Helper function to get all possible combinations
            function combine(arr, size, index = 0, current = []) {
                if (current.length === size) {
                    return [current];
                }
                if (index === arr.length) {
                    return [];
                }
        
                const result = [];
                for (const bet of arr[index]) {
                    result.push(...combine(arr, size, index + 1, [...current, bet]));
                }
                result.push(...combine(arr, size, index + 1, current));
        
                return result;
            }
        
            return combine(eventGroups, combinationSize);
        },
        combinations(bets) {
            var combs = [];
            const uniqueEventIds = [...new Set(bets.map(bet => bet.eventId))];
            const possibleSizes = [];
        
            for (let i = 1; i <= uniqueEventIds.length; i++) {
                //combs.push(this.getSystemCombinations(bets, i));
                var k_combs = this.getSystemCombinations(bets, i);
                combs[i] = k_combs
                /*
                for (i = 0; i < k_combs.length; i++) {
                    combs.push(k_combs[i]);
                } */
            }
        
            return combs;
        },
        /*
        combinations (set) {
            var k, i, combs, k_combs;
            combs = [];
            // Calculate all non-empty k-combinations
            for (k = 1; k <= set.length; k++) {
                k_combs = this.combinationSets(set, k);
                for (i = 0; i < k_combs.length; i++) {
                    combs.push(k_combs[i]);
                }
            }
            console.log(combs)
            return combs;
        }, */
        combinationSets (set, k) {
            var i, j, combs, head, tailcombs;

            // There is no way to take e.g. sets of 5 elements from
            // a set of 4.
            if (k > set.length || k <= 0) {
                return [];
            }

            // K-sized set has only one K-sized subset.
            if (k == set.length) {
                return [set];
            }

            // There is N 1-sized subsets in a N-sized set.
            if (k == 1) {
                combs = [];
                for (i = 0; i < set.length; i++) {
                    combs.push([set[i]]);
                }
                return combs;
            }

            combs = [];
            for (i = 0; i < set.length - k + 1; i++) {
                // head is a list that includes only our current element.
                head = set.slice(i, i + 1);
                // We take smaller combinations from the subsequent elements
                tailcombs = this.combinationSets(set.slice(i + 1), k - 1);
                // For each (k-1)-combination we join it with the current
                // and store it to the set of k-combinations.
                for (j = 0; j < tailcombs.length; j++) {
                    combs.push(head.concat(tailcombs[j]));
                }
            }
            return combs;
        },
        toFloat (e) {
            if (typeof (e) === 'number') return e;
            if (typeof (e) === 'string') {
                var str = e.trim();
                var value = Number(e.replace(/[^0-9.-]+/g, ""));
                return str.startsWith('(') && str.endsWith(')') ? -value: value;
            }

            return e;
        },
        cashout (id,pin) {
            var AppId = this.$root.app.id;
            return this.$http.get(bsapi+'api/v1/bet-cash-out/'+id+'?pin='+pin, { headers: { 'X-App': '' +AppId } });
        },
        cashoutNow (id,pin) {
            var AppId = this.$root.app.id;
            return this.$http.post(bsapi+'api/v1/bet-cash-out/'+id+'?pin='+pin, {}, { headers: { 'X-App': '' +AppId } });
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/betSlip.js